export default __webpack_public_path__ + "static/media/julide-atasayar.637da154.png";